import { faChartLineUp, faTrophy, faVideo, faPenClip } from '@fortawesome/pro-regular-svg-icons';

export const selectOptions = [
  {
    id: '1',
    label: 'Chart',
    value: 'chart',
    icon: faChartLineUp,
  },
  {
    id: '2',
    label: 'Scoreboard',
    value: 'scoreboard',
    icon: faTrophy,
  },
  {
    id: '3',
    label: 'Video',
    value: 'Video',
    icon: faVideo,
  },
  {
    id: '4',
    label: 'Write-ups',
    value: 'write-ups',
    icon: faPenClip,
  },
];
